// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3dI08","insightsList":"newBusinessInsightsMenu_insightsList__2sizk","active":"newBusinessInsightsMenu_active__2vhqx"};